module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 18);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("bn.js");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ecCurve; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return encrypt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return decrypt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isEmptyObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isErrorObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return prettyPrintError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return generateAddressFromPublicKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return normalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return generatePrivateExcludingIndexes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KEY_NOT_FOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return derivePubKeyXFromPolyID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return stripHexPrefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return generateID; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _toruslabs_eccrypto__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var _toruslabs_eccrypto__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_toruslabs_eccrypto__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var bn_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1);
/* harmony import */ var bn_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(bn_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var elliptic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14);
/* harmony import */ var elliptic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(elliptic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var web3_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9);
/* harmony import */ var web3_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(web3_utils__WEBPACK_IMPORTED_MODULE_5__);






// const privKeyBnToEcc = (bnPrivKey) => {
//   return bnPrivKey.toBuffer("be", 32);
// };
// const privKeyBnToPubKeyECC = (bnPrivKey) => {
//   return getPublic(privKeyBnToEcc(bnPrivKey));
// };
var ecCurve = new elliptic__WEBPACK_IMPORTED_MODULE_4__["ec"]("secp256k1"); // Wrappers around ECC encrypt/decrypt to use the hex serialization
// TODO: refactor to take BN

function encrypt(_x, _x2) {
  return _encrypt.apply(this, arguments);
}

function _encrypt() {
  _encrypt = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee(publicKey, msg) {
    var encryptedDetails;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Object(_toruslabs_eccrypto__WEBPACK_IMPORTED_MODULE_2__["encrypt"])(publicKey, msg);

          case 2:
            encryptedDetails = _context.sent;
            return _context.abrupt("return", {
              ciphertext: encryptedDetails.ciphertext.toString("hex"),
              ephemPublicKey: encryptedDetails.ephemPublicKey.toString("hex"),
              iv: encryptedDetails.iv.toString("hex"),
              mac: encryptedDetails.mac.toString("hex")
            });

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _encrypt.apply(this, arguments);
}

function decrypt(_x3, _x4) {
  return _decrypt.apply(this, arguments);
}

function _decrypt() {
  _decrypt = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee2(privKey, msg) {
    var bufferEncDetails;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            bufferEncDetails = {
              ciphertext: Buffer.from(msg.ciphertext, "hex"),
              ephemPublicKey: Buffer.from(msg.ephemPublicKey, "hex"),
              iv: Buffer.from(msg.iv, "hex"),
              mac: Buffer.from(msg.mac, "hex")
            };
            return _context2.abrupt("return", Object(_toruslabs_eccrypto__WEBPACK_IMPORTED_MODULE_2__["decrypt"])(privKey, bufferEncDetails));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _decrypt.apply(this, arguments);
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}
var isErrorObj = function isErrorObj(err) {
  return err && err.stack && err.message !== "";
};
function prettyPrintError(error) {
  if (isErrorObj(error)) {
    return error.message;
  }

  return error.toString();
}
function generateAddressFromPublicKey(publicKey) {
  var ethAddressLower = "0x".concat(Object(web3_utils__WEBPACK_IMPORTED_MODULE_5__["keccak256"])(publicKey.toString("hex")).slice(64 - 38));
  return Object(web3_utils__WEBPACK_IMPORTED_MODULE_5__["toChecksumAddress"])(ethAddressLower);
}
function normalize(input) {
  if (!input) {
    return undefined;
  }

  var hexString;

  if (typeof input === "number") {
    hexString = input.toString(16);

    if (hexString.length % 2) {
      hexString = "0".concat(hexString);
    }
  }

  if (typeof input === "string") {
    hexString = input.toLowerCase();
  }

  return "0x".concat(hexString);
}
function generatePrivateExcludingIndexes(shareIndexes) {
  var key = new bn_js__WEBPACK_IMPORTED_MODULE_3___default.a(Object(_toruslabs_eccrypto__WEBPACK_IMPORTED_MODULE_2__["generatePrivate"])());

  if (shareIndexes.find(function (el) {
    return el.eq(key);
  })) {
    return generatePrivateExcludingIndexes(shareIndexes);
  }

  return key;
}
var KEY_NOT_FOUND = "KEY_NOT_FOUND";
function derivePubKeyXFromPolyID(polyID) {
  return polyID.split("|")[0].slice(2);
}
function stripHexPrefix(str) {
  if (str.slice(0, 2) === "0x") return str.slice(2);
  return str;
}
function generateID() {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return "".concat(Math.random().toString(36).substr(2, 9));
}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("@toruslabs/eccrypto");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/regenerator");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("web3-utils");

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/getPrototypeOf");

/***/ }),
/* 11 */
/***/ (function(module, exports) {



/***/ }),
/* 12 */
/***/ (function(module, exports) {



/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "k", function() { return /* reexport */ BNUtils_toPrivKeyEC; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* reexport */ BNUtils_toPrivKeyECC; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ BNUtils_getPubKeyEC; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* reexport */ BNUtils_getPubKeyECC; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* reexport */ BNUtils_getPubKeyPoint; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ Error_TkeyError; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ base_Point; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ base_Polynomial; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ base_PublicPolynomial; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ base_PublicShare; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ base_Share; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ base_ShareStore; });

// EXTERNAL MODULE: external "@toruslabs/eccrypto"
var eccrypto_ = __webpack_require__(5);

// EXTERNAL MODULE: external "bn.js"
var external_bn_js_ = __webpack_require__(1);
var external_bn_js_default = /*#__PURE__*/__webpack_require__.n(external_bn_js_);

// EXTERNAL MODULE: ./src/utils.ts
var utils = __webpack_require__(4);

// EXTERNAL MODULE: external "@babel/runtime/helpers/classCallCheck"
var classCallCheck_ = __webpack_require__(2);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/createClass"
var createClass_ = __webpack_require__(3);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(0);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// CONCATENATED MODULE: ./src/base/Point.ts






var Point_Point = /*#__PURE__*/function () {
  function Point(x, y) {
    classCallCheck_default()(this, Point);

    defineProperty_default()(this, "x", void 0);

    defineProperty_default()(this, "y", void 0);

    this.x = new external_bn_js_default.a(x, "hex");
    this.y = new external_bn_js_default.a(y, "hex");
  } // complies with EC and elliptic pub key types
  // eslint-disable-next-line @typescript-eslint/no-explicit-any


  createClass_default()(Point, [{
    key: "encode",
    value: function encode(enc, params) {
      switch (enc) {
        case "arr":
          return Buffer.concat([Buffer.from("0x04", "hex"), Buffer.from(this.x.toString("hex"), "hex"), Buffer.from(this.y.toString("hex"), "hex")]);

        case "elliptic-compressed":
          {
            // TODO: WHAT IS THIS.?
            var ec = params;
            ec = utils["d" /* ecCurve */];
            var key = ec.keyFromPublic({
              x: this.x.toString("hex"),
              y: this.y.toString("hex")
            }, "hex");
            return Buffer.from(key.getPublic(true, "hex"));
          }

        default:
          throw new Error("encoding doesnt exist in Point");
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        x: this.x.toString("hex"),
        y: this.y.toString("hex")
      };
    }
  }], [{
    key: "fromCompressedPub",
    value: function fromCompressedPub(value) {
      var key = utils["d" /* ecCurve */].keyFromPublic(value, "hex");
      var pt = key.getPublic();
      return new Point(pt.getX(), pt.getY());
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(value) {
      var x = value.x,
          y = value.y;
      return new Point(x, y);
    }
  }]);

  return Point;
}();

/* harmony default export */ var base_Point = (Point_Point);
// CONCATENATED MODULE: ./src/base/BNUtils.ts



 // These functions are here because BN can't be extended

var BNUtils_toPrivKeyEC = function toPrivKeyEC(bn) {
  return utils["d" /* ecCurve */].keyFromPrivate(bn.toString("hex", 64));
};
var BNUtils_toPrivKeyECC = function toPrivKeyECC(bn) {
  var tmp = new external_bn_js_default.a(bn, "hex");
  return Buffer.from(tmp.toString("hex", 64), "hex");
};
var BNUtils_getPubKeyEC = function getPubKeyEC(bn) {
  return utils["d" /* ecCurve */].keyFromPrivate(bn.toString("hex", 64)).getPublic();
};
var BNUtils_getPubKeyECC = function getPubKeyECC(bn) {
  return Object(eccrypto_["getPublic"])(BNUtils_toPrivKeyECC(bn));
};
var BNUtils_getPubKeyPoint = function getPubKeyPoint(bn) {
  var pubKeyEc = BNUtils_getPubKeyEC(bn);
  return new base_Point(pubKeyEc.getX().toString("hex"), pubKeyEc.getY().toString("hex"));
};
// EXTERNAL MODULE: external "@babel/runtime/helpers/assertThisInitialized"
var assertThisInitialized_ = __webpack_require__(7);
var assertThisInitialized_default = /*#__PURE__*/__webpack_require__.n(assertThisInitialized_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/inherits"
var inherits_ = __webpack_require__(15);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/possibleConstructorReturn"
var possibleConstructorReturn_ = __webpack_require__(16);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/getPrototypeOf"
var getPrototypeOf_ = __webpack_require__(10);
var getPrototypeOf_default = /*#__PURE__*/__webpack_require__.n(getPrototypeOf_);

// EXTERNAL MODULE: external "ts-custom-error"
var external_ts_custom_error_ = __webpack_require__(17);

// CONCATENATED MODULE: ./src/base/Error.ts








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = getPrototypeOf_default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf_default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn_default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

 // @flow

var Error_TkeyError = /*#__PURE__*/function (_CustomError) {
  inherits_default()(TkeyError, _CustomError);

  var _super = _createSuper(TkeyError);

  function TkeyError(code, message) {
    var _this;

    classCallCheck_default()(this, TkeyError);

    // takes care of stack and proto
    _this = _super.call(this, message);

    defineProperty_default()(assertThisInitialized_default()(_this), "code", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "message", void 0);

    _this.code = code;
    _this.message = message || ""; // Set name explicitly as minification can mangle class names

    Object.defineProperty(assertThisInitialized_default()(_this), "name", {
      value: "TkeyError"
    });
    return _this;
  }

  createClass_default()(TkeyError, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        code: this.code,
        message: this.message
      };
    }
  }, {
    key: "toString",
    value: function toString() {
      return JSON.stringify(this.toJSON());
    }
  }]);

  return TkeyError;
}(external_ts_custom_error_["CustomError"]);
// CONCATENATED MODULE: ./src/base/PublicPolynomial.ts





var PublicPolynomial_PublicPolynomial = /*#__PURE__*/function () {
  function PublicPolynomial(polynomialCommitments) {
    classCallCheck_default()(this, PublicPolynomial);

    defineProperty_default()(this, "polynomialCommitments", void 0);

    defineProperty_default()(this, "polynomialId", void 0);

    this.polynomialCommitments = polynomialCommitments;
  }

  createClass_default()(PublicPolynomial, [{
    key: "getThreshold",
    value: function getThreshold() {
      return this.polynomialCommitments.length;
    }
  }, {
    key: "getPolynomialID",
    value: function getPolynomialID() {
      var idSeed = "";

      for (var i = 0; i < this.polynomialCommitments.length; i += 1) {
        var nextChunk = this.polynomialCommitments[i].encode("elliptic-compressed").toString();

        if (i !== 0) {
          nextChunk = "|".concat(nextChunk);
        }

        idSeed += nextChunk;
      }

      this.polynomialId = idSeed;
      return this.polynomialId;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        polynomialCommitments: this.polynomialCommitments
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(value) {
      var points = value.polynomialCommitments.map(function (x) {
        return base_Point.fromJSON(x);
      });
      return new PublicPolynomial(points);
    }
  }]);

  return PublicPolynomial;
}(); // @flow


/* harmony default export */ var base_PublicPolynomial = (PublicPolynomial_PublicPolynomial);
// CONCATENATED MODULE: ./src/base/PublicShare.ts






var PublicShare_PublicShare = /*#__PURE__*/function () {
  function PublicShare(shareIndex, shareCommitment) {
    classCallCheck_default()(this, PublicShare);

    defineProperty_default()(this, "shareCommitment", void 0);

    defineProperty_default()(this, "shareIndex", void 0);

    this.shareCommitment = new base_Point(shareCommitment.x, shareCommitment.y);
    this.shareIndex = new external_bn_js_default.a(shareIndex, "hex");
  }

  createClass_default()(PublicShare, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        shareCommitment: this.shareCommitment,
        shareIndex: this.shareIndex.toString("hex")
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(value) {
      var shareCommitment = value.shareCommitment,
          shareIndex = value.shareIndex;
      return new PublicShare(shareIndex, base_Point.fromJSON(shareCommitment));
    }
  }]);

  return PublicShare;
}();

/* harmony default export */ var base_PublicShare = (PublicShare_PublicShare);
// CONCATENATED MODULE: ./src/base/Share.ts







var Share_Share = /*#__PURE__*/function () {
  function Share(shareIndex, share) {
    classCallCheck_default()(this, Share);

    defineProperty_default()(this, "share", void 0);

    defineProperty_default()(this, "shareIndex", void 0);

    this.share = new external_bn_js_default.a(share, "hex");
    this.shareIndex = new external_bn_js_default.a(shareIndex, "hex");
  }

  createClass_default()(Share, [{
    key: "getPublicShare",
    value: function getPublicShare() {
      return new base_PublicShare(this.shareIndex, BNUtils_getPubKeyPoint(this.share));
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        share: this.share.toString("hex"),
        shareIndex: this.shareIndex.toString("hex")
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(value) {
      var share = value.share,
          shareIndex = value.shareIndex;
      return new Share(shareIndex, share);
    }
  }]);

  return Share;
}();

/* harmony default export */ var base_Share = (Share_Share);
// CONCATENATED MODULE: ./src/base/Polynomial.ts







 // @flow

var Polynomial_Polynomial = /*#__PURE__*/function () {
  function Polynomial(polynomial) {
    classCallCheck_default()(this, Polynomial);

    defineProperty_default()(this, "polynomial", void 0);

    defineProperty_default()(this, "publicPolynomial", void 0);

    this.polynomial = polynomial;
  }

  createClass_default()(Polynomial, [{
    key: "getThreshold",
    value: function getThreshold() {
      return this.polynomial.length;
    }
  }, {
    key: "polyEval",
    value: function polyEval(x) {
      var tmpX = new external_bn_js_default.a(x, "hex");
      var xi = new external_bn_js_default.a(tmpX);
      var sum = new external_bn_js_default.a(0);
      sum = sum.add(this.polynomial[0]);

      for (var i = 1; i < this.polynomial.length; i += 1) {
        var tmp = xi.mul(this.polynomial[i]);
        sum = sum.add(tmp);
        sum = sum.umod(utils["d" /* ecCurve */].curve.n);
        xi = xi.mul(new external_bn_js_default.a(tmpX));
        xi = xi.umod(utils["d" /* ecCurve */].curve.n);
      }

      return sum;
    }
  }, {
    key: "generateShares",
    value: function generateShares(shareIndexes) {
      var newShareIndexes = shareIndexes.map(function (index) {
        if (typeof index === "number") {
          return new external_bn_js_default.a(index);
        }

        if (index instanceof external_bn_js_default.a) {
          return index;
        }

        if (typeof index === "string") {
          return new external_bn_js_default.a(index, "hex");
        }

        return index;
      });
      var shares = {};

      for (var _x = 0; _x < newShareIndexes.length; _x += 1) {
        shares[newShareIndexes[_x].toString("hex")] = new base_Share(newShareIndexes[_x], this.polyEval(newShareIndexes[_x]));
      }

      return shares;
    }
  }, {
    key: "getPublicPolynomial",
    value: function getPublicPolynomial() {
      var polynomialCommitments = [];

      for (var i = 0; i < this.polynomial.length; i += 1) {
        polynomialCommitments.push(BNUtils_getPubKeyPoint(this.polynomial[i]));
      }

      this.publicPolynomial = new base_PublicPolynomial(polynomialCommitments);
      return this.publicPolynomial;
    }
  }, {
    key: "getPolynomialID",
    value: function getPolynomialID() {
      return this.publicPolynomial.polynomialId;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        polynomial: this.polynomial.map(function (x) {
          return x.toString("hex");
        })
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(value) {
      var polynomial = value.polynomial;
      return new Polynomial(polynomial.map(function (x) {
        return new external_bn_js_default.a(x, "hex");
      }));
    }
  }]);

  return Polynomial;
}();

/* harmony default export */ var base_Polynomial = (Polynomial_Polynomial);
// CONCATENATED MODULE: ./src/base/ShareStore.ts





var ShareStore_ShareStore = /*#__PURE__*/function () {
  function ShareStore(share, polynomialID) {
    classCallCheck_default()(this, ShareStore);

    defineProperty_default()(this, "share", void 0);

    defineProperty_default()(this, "polynomialID", void 0);

    this.share = share;
    this.polynomialID = polynomialID;
  }

  createClass_default()(ShareStore, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        share: this.share,
        polynomialID: this.polynomialID.toString()
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(value) {
      var share = value.share,
          polynomialID = value.polynomialID;
      return new ShareStore(base_Share.fromJSON(share), polynomialID);
    }
  }]);

  return ShareStore;
}();

/* harmony default export */ var base_ShareStore = (ShareStore_ShareStore);
// CONCATENATED MODULE: ./src/base/index.ts













/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = require("elliptic");

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inherits");

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/possibleConstructorReturn");

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = require("ts-custom-error");

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _src_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "toPrivKeyEC", function() { return _src_base__WEBPACK_IMPORTED_MODULE_0__["k"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "toPrivKeyECC", function() { return _src_base__WEBPACK_IMPORTED_MODULE_0__["l"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getPubKeyEC", function() { return _src_base__WEBPACK_IMPORTED_MODULE_0__["h"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getPubKeyECC", function() { return _src_base__WEBPACK_IMPORTED_MODULE_0__["i"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getPubKeyPoint", function() { return _src_base__WEBPACK_IMPORTED_MODULE_0__["j"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TkeyError", function() { return _src_base__WEBPACK_IMPORTED_MODULE_0__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Point", function() { return _src_base__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Polynomial", function() { return _src_base__WEBPACK_IMPORTED_MODULE_0__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PublicPolynomial", function() { return _src_base__WEBPACK_IMPORTED_MODULE_0__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PublicShare", function() { return _src_base__WEBPACK_IMPORTED_MODULE_0__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Share", function() { return _src_base__WEBPACK_IMPORTED_MODULE_0__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ShareStore", function() { return _src_base__WEBPACK_IMPORTED_MODULE_0__["f"]; });

/* harmony import */ var _src_baseTypes_aggregateTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11);
/* harmony import */ var _src_baseTypes_aggregateTypes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_src_baseTypes_aggregateTypes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _src_baseTypes_aggregateTypes__WEBPACK_IMPORTED_MODULE_1__) if(["default","toPrivKeyEC","toPrivKeyECC","getPubKeyEC","getPubKeyECC","getPubKeyPoint","TkeyError","Point","Polynomial","PublicPolynomial","PublicShare","Share","ShareStore"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _src_baseTypes_aggregateTypes__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _src_baseTypes_commonTypes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12);
/* harmony import */ var _src_baseTypes_commonTypes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_src_baseTypes_commonTypes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _src_baseTypes_commonTypes__WEBPACK_IMPORTED_MODULE_2__) if(["default","toPrivKeyEC","toPrivKeyECC","getPubKeyEC","getPubKeyECC","getPubKeyPoint","TkeyError","Point","Polynomial","PublicPolynomial","PublicShare","Share","ShareStore"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _src_baseTypes_commonTypes__WEBPACK_IMPORTED_MODULE_2__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _src_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ecCurve", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_3__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "encrypt", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_3__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "decrypt", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_3__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isEmptyObject", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_3__["i"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isErrorObj", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_3__["j"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "prettyPrintError", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_3__["l"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "generateAddressFromPublicKey", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_3__["f"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "normalize", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_3__["k"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "generatePrivateExcludingIndexes", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_3__["h"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "KEY_NOT_FOUND", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "derivePubKeyXFromPolyID", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_3__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "stripHexPrefix", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_3__["m"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "generateID", function() { return _src_utils__WEBPACK_IMPORTED_MODULE_3__["g"]; });






/***/ })
/******/ ]);